// routes
import {paths} from 'src/routes/paths';
// components
import SvgColor from 'src/components/svg-color';
import {usePermission} from 'src/hooks/use-permission';
import {useSelector} from 'react-redux';
import {usePermissions} from 'src/hooks/use-permissions';
import {getUserManualUrl} from 'src/utils/userManual';
import {usePlatform} from 'src/hooks/use-platform';
import {hasEndpointLimitsAccess} from 'src/utils/endpoint-limits';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{width: 1, height: 1}} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

// ----------------------------------------------------------------------

export function useNavData() {
  const {isCreator, isApprover} = usePermission()
  const bidBlocks = useSelector(state => state.app.settings.bidBlocks)
  const operations = {title: 'Операции', path: paths.dashboard.root, icon: icon('operations')}
  const registers = {title: 'Реестры', path: paths.registers.root, icon: icon('registers')}
  const employees = {title: 'Сотрудники', path: paths.employees.root, icon: icon('employees')}
  const transports = {title: 'Транспорт', path: paths.transports.root, icon: icon('transports')}
  const endpoints = {title: 'Точки', path: paths.endpoints.root, icon: icon('endpoints')}
  const docTemplates = {title: 'Документы', path: paths.docTemplates.root, icon: icon('doc-templates')}
  const sellers = {title: 'Контрагенты', path: paths.sellers.root, icon: icon('sellers')}
  const reports = {title: 'Выгрузки', path: paths.reports.root, icon: icon('reports')}
  const nomenclatures = {title: 'Номенклатура', path: paths.nomenclatures.root, icon: icon('reports')}
  const companies = {title: 'Компании', path: paths.companies.root, icon: icon('endpoints')}

  const permissions = useSelector(store => store.user?.permissions)
  const {personalAccountSettings} = usePermissions()
  const {isPlatformOwner} = usePlatform()


  const selectedEndpointId = useSelector(store => store.endpoint.selectedEndpoint?.id)
  const endpointPermissions = permissions?.endpoints ? permissions.endpoints[selectedEndpointId] : {}

  const canEditEndpoint = endpointPermissions?.merchant_permissions?.can_edit_endpoint
  const canCreateEndpoint = endpointPermissions?.merchant_permissions?.can_create_endpoint

  const canEditEmployee = endpointPermissions?.merchant_permissions?.can_edit_employee
  const canCreateEmployee = endpointPermissions?.merchant_permissions?.can_create_employee

  const role = permissions?.user_data?.role

  const isAuto = bidBlocks?.auto?.display


  const isLight = personalAccountSettings?.show_documents_generation === false

  const isReciept = personalAccountSettings?.show_nomenclature_for_receipt === true


  const items = []

  items.push(operations)
  items.push(reports)

  if (isPlatformOwner) {
    items.push(companies)
  }

  if (isReciept || (!isLight && !isAuto)) {
    items.push(nomenclatures)
    // items.push(transports)
  }

  if (isApprover || isCreator) {
    items.push(registers)
  }

  if (canEditEndpoint || canCreateEndpoint || hasEndpointLimitsAccess(permissions, endpointPermissions?.merchant_id)) {
    items.push(endpoints)
  }

  items.push(sellers)
  if (canEditEmployee || canCreateEmployee) {
    items.push(employees)
  }

  if (endpointPermissions?.can_create_document_template || endpointPermissions?.can_edit_document_template) {
    items.push(docTemplates)
  }

  const data = [
    {
      subheader: 'ОСНОВНЫЕ',
      items,

    },
  ]

  return data;
}

export function useSubNavData() {
  const {isCreator, isApprover} = usePermission()
  const userManual = {
    title: 'Руководство пользователя', path: getUserManualUrl(),
    icon: icon('usermanual')
  }

  const items = []

  items.push(userManual)

  const data = [
    {
      items,
    },
  ]

  return data;
}
